const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQrCodeSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F19"
    },
    d: "M428.522,166.957h-66.783c-9.217,0-16.696-7.473-16.696-16.696V83.478 c0-9.223,7.479-16.696,16.696-16.696h66.783c9.217,0,16.696,7.473,16.696,16.696v66.783 C445.217,159.484,437.739,166.957,428.522,166.957z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.261,
    y: 278.261,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.261,
    y: 345.043,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.261,
    y: 411.826,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.652,
    y: 311.652,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.652,
    y: 378.435,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.652,
    y: 445.217,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.043,
    y: 278.261,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.043,
    y: 345.043,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.043,
    y: 411.826,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.435,
    y: 311.652,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.435,
    y: 378.435,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 378.435,
    y: 445.217,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 411.826,
    y: 278.261,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.826,
    y: 345.043,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.826,
    y: 411.826,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.217,
    y: 311.652,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.217,
    y: 378.435,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 445.217,
    y: 445.217,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 278.261,
    y: 478.609,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.043,
    y: 478.609,
    style: {
      fill: "#FF9F19"
    },
    width: 33.391,
    height: 33.391
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 411.826,
    y: 478.609,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.609,
    y: 278.261,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.609,
    y: 345.043,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.609,
    y: 411.826,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 478.609,
    y: 478.609,
    style: {
      fill: "#F28618"
    },
    width: 33.391,
    height: 33.391
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC33"
    },
    d: "M512,16.696C512,7.473,504.521,0,495.304,0H395.13"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28618"
    },
    d: "M428.522,66.783H395.13v100.174h33.391c9.217,0,16.696-7.473,16.696-16.696V83.478 C445.217,74.256,437.739,66.783,428.522,66.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F19"
    },
    d: "M150.261,166.957H83.478c-9.217,0-16.696-7.473-16.696-16.696V83.478 c0-9.223,7.479-16.696,16.696-16.696h66.783c9.217,0,16.696,7.473,16.696,16.696v66.783 C166.957,159.484,159.478,166.957,150.261,166.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28618"
    },
    d: "M150.261,66.783H116.87v100.174h33.391c9.217,0,16.696-7.473,16.696-16.696V83.478 C166.957,74.256,159.478,66.783,150.261,66.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F19"
    },
    d: "M150.261,445.217H83.478c-9.217,0-16.696-7.473-16.696-16.696v-66.783 c0-9.223,7.479-16.696,16.696-16.696h66.783c9.217,0,16.696,7.473,16.696,16.696v66.783 C166.957,437.744,159.478,445.217,150.261,445.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28618"
    },
    d: "M150.261,345.043H116.87v100.174h33.391c9.217,0,16.696-7.473,16.696-16.696v-66.783 C166.957,352.516,159.478,345.043,150.261,345.043z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F19"
    },
    d: "M217.043,233.739H16.696C7.479,233.739,0,226.266,0,217.043V16.696C0,7.473,7.479,0,16.696,0 h200.348c9.217,0,16.696,7.473,16.696,16.696v200.348C233.739,226.266,226.261,233.739,217.043,233.739z M33.391,200.348h166.957 V33.391H33.391V200.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F19"
    },
    d: "M217.043,512H16.696C7.479,512,0,504.527,0,495.304V294.957c0-9.223,7.479-16.696,16.696-16.696 h200.348c9.217,0,16.696,7.473,16.696,16.696v200.348C233.739,504.527,226.261,512,217.043,512z M33.391,478.609h166.957V311.652 H33.391V478.609z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28618"
    },
    d: "M217.043,0H116.87v33.391h83.478v166.957H116.87v33.391h100.174c9.217,0,16.696-7.473,16.696-16.696 V16.696C233.739,7.473,226.261,0,217.043,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28618"
    },
    d: "M217.043,278.261H116.87v33.391h83.478v166.957H116.87V512h100.174 c9.217,0,16.696-7.473,16.696-16.696V294.957C233.739,285.734,226.261,278.261,217.043,278.261z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.13,
    y: 311.652,
    style: {
      fill: "#F28618"
    },
    width: 16.696,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.13,
    y: 378.435,
    style: {
      fill: "#F28618"
    },
    width: 16.696,
    height: 33.391
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.13,
    y: 445.217,
    style: {
      fill: "#F28618"
    },
    width: 16.696,
    height: 33.391
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9F19"
    },
    d: "M495.304,233.739H294.957c-9.217,0-16.696-7.473-16.696-16.696V16.696 C278.261,7.473,285.739,0,294.957,0h200.348C504.521,0,512,7.473,512,16.696v200.348C512,226.266,504.521,233.739,495.304,233.739z  M311.652,200.348h166.957V33.391H311.652V200.348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F28618"
    },
    d: "M495.304,0H395.13v33.391h83.478v166.957H395.13v33.391h100.174c9.217,0,16.696-7.473,16.696-16.696 V16.696C512,7.473,504.521,0,495.304,0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCodeSvgrepoCom);
export default __webpack_public_path__ + "static/media/qr_code_svgrepo_com.aaa58af4f92a1e5aec25a8ec008c583d.svg";
export { ForwardRef as ReactComponent };